import './App.css';
import {
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from 'routes/HomePage';
import { AdminPage } from 'routes/AdminPage';
import { About } from 'routes/About';
import { ArticlesNewPage } from 'routes/ArticlesNewPage';
import { ArticlePage } from 'routes/ArticlePage';
import { Settings } from 'routes/Settings';
import { TablePage } from 'routes/TablePage';
import { CommunityPage } from 'routes/CommunityPage';
import { EventPage } from 'routes/EventPage';
import { TreeMapPage } from 'routes/TreeMapPage';
import { Principle } from 'routes/Principle';
import { NotFoundPage } from 'routes/NotFoundPage';
import { CountryPage } from 'routes/CountryPage';
import { StockPage } from 'routes/StockPage';
import { InfoPage } from 'routes/StockPage';
import { OpinionPage as StockOpinionsPage } from 'routes/StockPage';
import { ProfilePage } from 'routes/ProfilePage';
import { NewsPage } from 'routes/StockPage';
import { FinishSignInPage } from 'routes/FinishSignInPage';
import { Bootstrap } from 'components/Bootstrap';
import { UserContext, useUserContext } from 'components/UserContext';
import { ModalContext, useModalContext } from 'components/ModalContext';
import { OpinionUpDownPage } from 'routes/StockPage/OpinionUpDownPage';

function App() {
  const userContextValue = useUserContext();
  const modalContextValue = useModalContext();

  return (
    <UserContext.Provider value={userContextValue}>
      <ModalContext.Provider value={modalContextValue}>
        <div className="d-flex flex-column h-100">
          <Header />
          {/* TODO: notice */}
          {/* TODO: push 배너 추가. 많이 하락한 종목이 발생하거나, 인기급상승한 의견이 생길경우 알려드릴게요. */}
          <Bootstrap />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/finishSignIn" element={<FinishSignInPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/articles/new" element={<ArticlesNewPage />} />
            <Route path="/articles/:id" element={<ArticlePage />} />
            <Route path="/settings" element={<Settings />} />
            <Route path=":countryCode" element={<CountryPage />}>
              <Route index element={<Navigate to="table" replace />} />
              <Route path="table" element={<TablePage />} />
              <Route path="treemap" element={<TreeMapPage />} />
            </Route>
            <Route path="/ideas" element={<CommunityPage />} />
            <Route path="/principle" element={<Principle />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/event" element={<EventPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/stocks/:symbol" element={<StockPage />}>
              <Route index element={<InfoPage />} />
              <Route path="opinions" element={<StockOpinionsPage />}>
                <Route index element={<Navigate to="up" replace />} />
                <Route path=":tab" element={<OpinionUpDownPage />} />
              </Route>
              <Route path="news" element={<NewsPage />} />
            </Route>
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <Footer />
        </div>
        {modalContextValue.modal}
      </ModalContext.Provider>
    </UserContext.Provider>
  );
}

export default App;
